module.exports = __webpack_public_path__ + "img/icon4.1d5c7550.png";